export const generateMockData = () => {
  const data = []
  const now = new Date()
  const oneYearAgo = new Date()
  oneYearAgo.setFullYear(now.getFullYear() - 1)
  // Generate hourly data for the past year
  let currentDate = new Date(oneYearAgo)
  while (currentDate <= now) {
    // Base value between 70-130 kWh
    let baseValue = 70 + Math.random() * 60
    // Add seasonal variation (higher in winter/summer)
    const month = currentDate.getMonth()
    if (month <= 1 || month >= 10) {
      // Winter (Nov-Feb)
      baseValue += 20 + Math.random() * 30
    } else if (month >= 5 && month <= 7) {
      // Summer (Jun-Aug)
      baseValue += 15 + Math.random() * 25
    }
    // Add time-of-day variation
    const hour = currentDate.getHours()
    if (hour >= 17 && hour <= 22) {
      // Evening peak
      baseValue += 10 + Math.random() * 20
    } else if (hour >= 0 && hour <= 5) {
      // Night low
      baseValue -= 30 + Math.random() * 20
    }
    // Add some random drops below threshold for demo purposes
    if (Math.random() < 0.02) {
      // 2% chance of a drop
      baseValue = 30 + Math.random() * 20 // Drop to 30-50 kWh
    }
    // Round to 2 decimal places
    const value = Math.round(baseValue * 100) / 100
    data.push({
      id: `reading-${data.length}`,
      timestamp: currentDate.toISOString(),
      value,
      unit: 'kWh',
    })
    // Move to next hour
    currentDate = new Date(currentDate.getTime() + 60 * 60 * 1000)
  }
  return data
}
export const getMonthName = (monthIndex: number): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return months[monthIndex]
}
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
}
